// frontend/utils/templates.ts
//
// 문서 템플릿.
//
// 템플릿은 별도 개념이 아니라 `isTemplate=true` 인 문서다. 새 문서 생성이 이미
// `sourceDocId` 복제(본문 Yjs·하위 문서·아이콘)를 지원하므로 그 기계를 그대로 쓴다.
//   - 템플릿으로 저장  = 원본을 복제해 사본에 플래그를 단다(원본은 그대로 남는다)
//   - 템플릿에서 만들기 = 기존 문서 생성 API 에 sourceDocId=<템플릿 id> 를 넘긴다
//
// 목록에서 템플릿이 새어 나오지 않는 것은 서버(aclService)가 보장한다.

import { API_URL, authHeaders, authOnlyHeaders } from "./api";

export type DocTemplate = {
  id: string;
  title: string;
  icon: string | null;
  workspaceType: string;
  creatorName: string | null;
  updatedAt: string;
  textSnippet: string | null;
};

/** 내가 쓸 수 있는 템플릿 목록. 실패하면 빈 배열(템플릿은 부가 기능이라 화면을 막지 않는다). */
export async function fetchTemplates(accessToken?: string): Promise<DocTemplate[]> {
  try {
    const res = await fetch(`${API_URL}/documents/templates`, { headers: authOnlyHeaders(accessToken) });
    if (!res.ok) return [];
    return await res.json();
  } catch {
    return [];
  }
}

/**
 * 현재 문서를 템플릿으로 저장한다(원본은 그대로 유지되고 사본이 템플릿이 된다).
 * @returns 실패 사유. 성공이면 null.
 */
export async function saveAsTemplate(
  docId: string,
  title: string,
  accessToken?: string,
  userName?: string,
): Promise<string | null> {
  try {
    const res = await fetch(`${API_URL}/documents/${docId}/save-as-template`, {
      method: "POST",
      headers: authHeaders(accessToken),
      body: JSON.stringify({ title, userName }),
    });
    if (res.ok) return null;
    const body = await res.json().catch(() => ({}));
    return body?.error || "템플릿 저장에 실패했습니다.";
  } catch {
    return "템플릿 저장에 실패했습니다.";
  }
}

/** 템플릿 해제(일반 문서로 되돌린다). */
export async function unsetTemplate(templateId: string, accessToken?: string): Promise<boolean> {
  try {
    const res = await fetch(`${API_URL}/documents/${templateId}/template`, {
      method: "DELETE",
      headers: authOnlyHeaders(accessToken),
    });
    return res.ok;
  } catch {
    return false;
  }
}
